import styled from 'styled-components'

export const FeaturesContainer = styled.div`
  margin: 0 auto;
  padding: 6rem 0;

  h2 {
    font-size: 36px;
    font-weight: 600;
    line-height: 45px;
    color: var(--dark);
    text-align: center;
    max-width: 1100px;
    display: block;
    margin: 0 auto 6rem auto;
  }

  @media (max-width: 1366px) {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  @media only screen and (max-width: 1050px) {
    h2 {
      font-size: 36px;
      line-height: 44px;
    }
  }

  @media only screen and (max-width: 700px) {
    padding-top: 3rem;
    padding-bottom: 3rem;

    h2 {
      font-size: 24px;
      line-height: 34px;
    }
  }
`

export const ItemsRow = styled.div`
  display: flex;
  justify-content: space-between;

  & > * {
    width: calc(100% / ${props => props.rowSize} - 2.5rem);

    @media only screen and (max-width: 700px) {
      width: 100%;
    }
  }

  &:not(:last-child) {
    margin-bottom: 3rem;
  }
`
